import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function getAllFailure(draft: Draft<IInterventionData>) {
  draft.getAll.config.isLoading = false;
  draft.getAll.config.errorMsg = 'Failed to get Interventions';
}

export default getAllFailure;
